export function getFYWeek(date: Date, startMonth: number): number {
  const fyStart = date.getMonth() + 1 >= startMonth
    ? new Date(date.getFullYear(), startMonth - 1, 1)
    : new Date(date.getFullYear() - 1, startMonth - 1, 1);
  const diff = date.getTime() - fyStart.getTime();
  return Math.floor(diff / (7 * 24 * 60 * 60 * 1000)) + 1;
}

export function getFYLabel(date: Date, startMonth: number): string {
  const fyStart = date.getMonth() + 1 >= startMonth
    ? new Date(date.getFullYear(), startMonth - 1, 1)
    : new Date(date.getFullYear() - 1, startMonth - 1, 1);
  const fyEnd = new Date(fyStart.getFullYear() + 1, startMonth - 1, 0);
  if (startMonth === 1) return `FY${fyStart.getFullYear()}`;
  return `FY${fyStart.getFullYear() % 100}/${fyEnd.getFullYear() % 100}`;
}

export function getFYQuarter(date: Date, startMonth: number): number {
  const monthOffset = (date.getMonth() + 1 - startMonth + 12) % 12;
  return Math.floor(monthOffset / 3) + 1;
}
